import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BankChangeRequest, Bankverbindung, PayloadBoolean, PayloadPolizzen, PayloadString, ZahlscheinChangeRequest } from '@karl/entities';
import { catchError, Observable } from 'rxjs';
import { RestService } from './rest.service';

@Injectable({
  providedIn: 'root'
})
export class RestPoliceService extends RestService {

  constructor(protected override http: HttpClient) {
    super(http);
  }

  getBenutzerDataPolizzen(): Observable<PayloadPolizzen> {
    return this.get<PayloadPolizzen>('/protected/benutzerdata/polizzen');
  }

  changeBankverbindung(polizzenNr: string, bankverbindung: Bankverbindung): Observable<PayloadBoolean> {
    const body = {
      polS:           polizzenNr,
      bankverbindung: bankverbindung
    } as BankChangeRequest;
    return this
      .put('/protected/change/bankverbindung', body);
  }

  generateSepaMandat(polizzenNr: string, bankverbindung: Bankverbindung): Observable<PayloadString> {
    const body = {
      polS:           polizzenNr,
      bankverbindung: bankverbindung
    } as BankChangeRequest;
    return this
      .patch('/protected/sepamandat/generate', body);
  }

  changeZahlschein(polizzenNr: string): Observable<PayloadBoolean> {
    const body = {
      polS: polizzenNr
    } as ZahlscheinChangeRequest;
    return this
      .put('/protected/change/zahlschein', body);
  }

  getDownloadVersicherungsBedingungenUrl(polizzenNummer: string): string {
    return this.secured_endpoint + '/file/download/versicherungsbedingungen/' + polizzenNummer;
  }

}
